import { Table, Tag, Tooltip } from "antd";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { roundToAnyDecimalPlaces } from "utilFunctions/helperFunctions/utilFunctions";
import { useNavigate } from "react-router-dom";
import InfoIcon from "Assets/Icons/InfoIcon";
import moment from "moment";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import styled from "styled-components";
const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;

const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const returnRiskSegment = (segment: string) => {
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <RiskStyledDiv color={colorCode?.bgColor}>
      <RiskStyledDSpan color={colorCode?.color}>
        {segment == "NA" ? "Low" : segment}
      </RiskStyledDSpan>
    </RiskStyledDiv>
  );
};
export const returnStatus = (status: string, item: any) => {
  const formattedDate = moment(item.date).format("D MMM YYYY");
  return (
    <Tag color={status === null ? "red" : status === "1" ? "green" : "red"}>
      {status === "1"
        ? "Active"
        : status === "0" && item.date !== null
        ? "Left on " + formattedDate
        : status === "0"
        ? "Left"
        : "Status Not available"}
    </Tag>
  );
};
interface MyBatchesTableAntdIF {
  data: any[];
  access: string;
  pagination: any;
  setPagination: any;
}
const MyBatchStudentDetailsTable = ({
  data,
  access,
  pagination,
  setPagination,
}: MyBatchesTableAntdIF) => {
  const navigate = useNavigate();

  const routeToPerformance = (item: any) => {
    navigate("/admin/performance/" + item.psid, {
      replace: false,
      state: {
        selectedStudent: item,
        referrer: location.pathname,
        myBatchRedirectSelect: "Student Details",
      },
    });
  };
  const columns: any = [
    {
      title: "Student Name",
      dataIndex: "studentName",
      width: 200,
      fixed: "left",
      access: ["Batches", "Dashboard"],
      render: (_: any, record: any) => {
        return (
          <span
            className="tableIdStyle"
            onClick={() => routeToPerformance(record)}
          >
            {record.studentName}
          </span>
        );
      },
    },
    {
      title: "PSID",
      dataIndex: "psid",
      width: 90,
      access: ["Batches"],
      render: (_: any, record: any) => {
        return <>{record.psid}</>;
      },
    },
    {
      title: () => (
        <Tooltip title="Student's overall class attendance for the current session">
          <span>Class Attendance</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "classAttended",
      width: 180,
      access: ["Batches"],
      render: (_: any, record: any) => {
        return (
          <>
            {" "}
            {record.classAttended}/{record.totalClass}
          </>
        );
      },
    },
    {
      title: "Test Attempted",
      dataIndex: "testCount",
      width: 120,
      access: ["Batches"],
      render: (_: any, record: any) => {
        return <>{record.testCount}</>;
      },
    },
    {
      title: () => (
        <Tooltip title="Likelihood of a student leaving the institute, calculated by an AI model based on performance, attendance, and other factors">
          <span>Risk Segment | LOP%</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "riskSegment",
      access: ["Batches"],
      width: 190,
      render: (_: any, item: any) => {
        return (
          <div className="d-flex flex-row align-items-center">
            <span className="pr-2">{returnRiskSegment(item.riskSegment)}</span>
            {item.risk > 0 && (
              <span>
                |{"  "}
                {roundToAnyDecimalPlaces(
                  Number(displayNumberWithDecimals(item.risk * 100)),
                  2
                )}{" "}
                %{" "}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      access: ["Batches", "Dashboard"],
      width: 160,
      render: (_: any, item: any) => {
        return <div>{returnStatus(item?.status, item)}</div>;
      },
    },
    {
      title: () => (
        <Tooltip title="Total number of follow-up comments on the student's profile by all faculty members">
          <span>Followups</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "followUpCounts",
      width: 120,
      access: ["Batches"],
      render: (_: any, item: any) => {
        return <div>{item?.followUpCounts}</div>;
      },
    },
  ];
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.columnKey || pagination.sortField;
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    setPagination({
      ...paginations,
      sortField,
      sortOrder: sortOrder,
    });
  };
  return (
    <Table
      className="antdTablePagination"
      scroll={{ x: "max-content" }}
      bordered
      size="small"
      columns={columns.filter((ele: any) => ele.access.includes(access))}
      dataSource={data}
      onChange={handleTableChange}
      pagination={pagination}
    />
  );
};
export default MyBatchStudentDetailsTable;
